export default class Currency {
    static locale;
    static currency;
    static style = {}

    static setLocale(locale) { this.locale = locale; return this; }
    static setCurrency(currency) { this.currency = currency; return this; }
    static setStyle(style) { this.style = style; return this; }

    /**
       Returns a formatted number.
     */
    static format(number, detail = {
        locale: null,
        currency: null,
        style: {}
    }) {
        let locale = this.locale
        let currency = this.currency
        let style = this.style

        if (
            detail.hasOwnProperty('locale')
            && detail.locale !== null
        ) {
            locale = detail.locale
        }
        if (
            detail.hasOwnProperty('currency')
            && detail.currency !== null
        ) {
            currency = detail.currency
        }
        if (
            detail.hasOwnProperty('style')
            && detail.style !== null
        ) {
            style = detail.style
        }

        return Intl.NumberFormat(locale, {
            style: 'currency',
            currency,
            ...style
        }).format(number);
    }

    static getCurrencySign(detail = {
        locale: null,
        style: null,
        currency: null
    }) {
        let locale = this.locale
        let currency = this.currency
        let style = this.style

        if (
            detail.hasOwnProperty('currency')
            && detail.currency !== null
        ) {
            currency = detail.currency
        }
        if (
            detail.hasOwnProperty('style')
            && detail.style !== null
        ) {
            style = detail.style
        }

        return Intl.NumberFormat(locale, {
            style: 'currency',
            currency,
            ...style
        })
            .formatToParts(0)
            .find(p => p.type === 'currency').value;

        // Returns '£' for example.
    }

    static ll_round(number) {
        const intPart = Math.floor(num);
        const decimal = num - intPart;

        if (decimal < 0.1) {
            return intPart; // round down
        } else if (decimal <= 0.49) {
            return intPart + 0.5; // round up to .5
        } else if (decimal <= 0.6) {
            return intPart + 0.5; // round to .5
        } else {
            return intPart + 1; // round up to next integer
        }
    }
}
